import { useState } from "react";
import { Paper, Box, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";
import styled from "styled-components";
import { CustomTabPanel, a11yProps } from "../../components/Tabs/accordionAndTabPanel";
import ReunioesAssessorados from "./Components/ReunioesAssessorados";
import ReunioesInternas from "./Components/ReunioesInternas";
import { useTranslation } from "../../commons/useTranslasion";

const Reunioes: React.FC = () => {
  const { translate } = useTranslation();
  const [value, setValue] = useState<number>(0);
  
  // Detecção de visualização mobile
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <DivReunioes>
      <PaperReunioes elevation={3}>
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              margin: isMobile ? "0px 0px !important" : "0px 25px !important",
            }}
          >
            <Tabs
              value={value}
              onChange={handleChangeTab}
              aria-label="tabs assessorado detalhes"
            >
              <Tab label={translate("reunioes")} {...a11yProps(0)} />
              <Tab label={translate("reunioesInternas")} {...a11yProps(1)} />
            </Tabs>
          </Box>
          {isMobile ? (
            // Versão com padding lateral reduzido para mobile - Reuniões
            <div
              role="tabpanel"
              hidden={value !== 0}
              id={`simple-tabpanel-0`}
              aria-labelledby={`simple-tab-0`}
            >
              {value === 0 && (
                <Box sx={{ py: 1, px: 0, mx: -2 }}>
                  <ReunioesAssessorados />
                </Box>
              )}
            </div>
          ) : (
            <CustomTabPanel value={value} index={0}>
              <ReunioesAssessorados />
            </CustomTabPanel>
          )}

          {isMobile ? (
            // Versão com padding lateral reduzido para mobile - Reuniões Internas
            <div
              role="tabpanel"
              hidden={value !== 1}
              id={`simple-tabpanel-1`}
              aria-labelledby={`simple-tab-1`}
            >
              {value === 1 && (
                <Box sx={{ py: 1, px: 0, mx: -2 }}>
                  <ReunioesInternas />
                </Box>
              )}
            </div>
          ) : (
            <CustomTabPanel value={value} index={1}>
              <ReunioesInternas />
            </CustomTabPanel>
          )}
        </Box>
      </PaperReunioes>
    </DivReunioes>
  );
};

export const DivReunioes = styled(Box)`
  margin: 20px;
  width: 100%;
  overflow: hidden;
`;
export const PaperReunioes = styled(Paper)`
  padding: 30px;
`;

export default Reunioes;
